import 'fine-uploader/lib/jquery/traditional';

const component = 'FileUpload';
const selectors = {
	field: `.${component}-field`,
	hidden: `.${component}-hidden`,
	cta: '.CTA',
	uploads: `.${component}-uploads`,
	error: `.${component}-error`,
};

let toggleSubmit = ($form, disable) => {
	let $submit = $form.find('.ContactForm-SubmitCTA');
	$submit.prop('disabled', !!disable);
};

export default function fileUpload() {
	$(selectors.field).each((i, element) => {
		let $field = $(element);
		let $form = $field.closest('form');
		let $hidden = $field.find(selectors.hidden);
		let validation = {
			allowedExtensions: $field.data('allowed-file-types') || ['jpeg', 'jpg', 'txt'],
			itemLimit: $field.data('max-files') || 3,
			sizeLimit: $field.data('max-file-size') || 51200, // 50 kB = 50 * 1024 bytes
		};
		let $error = $field.find(selectors.error);

		$field.fineUploader({
			template: 'qq-template-validation',
			button: $field.find(selectors.cta),
			request: {
				endpoint: $field.data('endpoint'),
				params: {
					allowedFileTypes: validation.allowedExtensions.join(','),
					maxFileSize: validation.sizeLimit,
					extraPath: 'rfp',
				},
			},
			validation: validation,
			disableCancelForFormUploads: true,
			callbacks: {
				onUpload: () => {
					toggleSubmit($form, true);
				},
				onAllComplete: () => {
					toggleSubmit($form);
				},
				onComplete: (id, name, jsonRes) => {
					if (jsonRes.s3Name) {
						let existingHidden = $hidden.val();
						let jsonValue = existingHidden ? JSON.parse(existingHidden) : [];
						jsonValue.push(jsonRes.s3Name);
						$hidden.val(JSON.stringify(jsonValue));
					}
				},
				onError: function (id, name, errorReason, xhrOrXdr) {
					$error.text(
						$field.format(
							'Error on file number {} - {}. Reason: {}',
							id,
							name,
							errorReason
						)
					);
				},
				onSubmit: function (id, name) {
					$error.text('');
				},
			},
			showMessage: function (message) {
				$error.text(message);
			},
		});

		$form.on('reset', event => {
			$hidden.val('');
			$field.find(selectors.uploads).empty();
		});
	});
}
